module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_memebox_m2.0a095e2027b541a508d3244d7a9bf905.png";